<template>
  <div class="middle cadfm-flexitem-stretched">

    <action-panel>
      <action-bar>
        <b-navbar-nav>
          <!--<action-button  @click="details"  icon="analytics-graph-bar" text="Details" tooltip="Tooltip1" :disabled="detailsButtonStatus"/>-->
          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="false" />
          <action-button @click="up" icon="up" bold :text="lang.button_Up" :tooltip="lang.button_Up"
            :disabled="upButtonStatus" />

          <action-button v-if="currentUser.role != 'Reader'" @click="checkConnectMPNToSE('derive')" icon="derive" bold
            :text="lang.button_Derive" :tooltip="lang.button_Derive" :disabled="deriveButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="checkConnectMPNToSE('assign')" icon="assign-part" bold
            :text="lang.button_Alternative" :tooltip="lang.button_Alternative" :disabled="alternativeButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="addPhysical" icon="add-physical" bold
            :text="lang.button_AddPhysical" :tooltip="lang.button_AddPhysical" :disabled="addPhysicalButtonStatus" />
          <action-button v-if="tabStatus==1 && currentUser.role != 'Reader'" @click="editPhysical" icon="edit" bold
            :text="lang.button_EditPhysical" :tooltip="lang.button_EditPhysical" :disabled="editPhysicalButtonStatus" />
          <action-button v-if="tabStatus==1 && currentUser.role != 'Reader'" @click="deletePhysical" icon="remove" bold
            :text="lang.button_DeletePhysical" :tooltip="lang.button_DeletePhysical"
            :disabled="deletePhysicalButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader' && globalSettings.requests" @click="createRequest" icon="new" bold
            :text="lang.button_CreateRequest" :tooltip="lang.button_CreateRequest" :disabled="requestButtonStatus" />

        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            text="Show panel left" tooltip="You can display left panel!" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            text="Show panel right" tooltip="You can display right panel!" :disabled="toggleButtonStatus" />

        </b-navbar-nav>

      </action-bar>

      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import TitleComponent from "@/components/shared/TitleComponent"
import Content from "@/components/PartManager/Views/PartSearch/Middle/Content/Content"
import * as Tools from '@/Tools/Tools'

export default {
  name: 'Middle',
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    TitleComponent,
    Content
  },
  props:{

    lang: Object
  },
  data () {
    return {
      //title: "Parts",
      detailsButtonStatus: true,
      deriveButtonStatus: true,
      editPhysicalButtonStatus: true,
      deletePhysicalButtonStatus: true,
      alternativeButtonStatus: true,
      addPhysicalButtonStatus: false,
      requestButtonStatus: true,
      backButtonStatus: false,
      upButtonStatus: false,
      toggleButtonStatus: false,
      toggleRightPanelIcon: 'view',
      pathToForBack: this.$route.query.from,
      tabStatus: 0,
      fileCounter: 0,
      fileFeedback: [],
      isAllowConnectMPNToSE: null
    }
  },
  created(){
    //setTimeout(this.changeIcon,5000)
  },
  computed: {
    ...mapGetters({

      //selectedRowsSearch: 'selectedRowsSearch',
      selectedSearchedRows: 'selectedSearchedRows',
      alternativePartsToBind: 'alternativePartsToBind',
      currentUser: 'currentUser',
      globalSettings: 'globalSettings'


    }),
    requestId() {
      if (this.$route.query.requestId != undefined && this.$route.query.requestId != null && this.$route.query.requestId != "") {
        return this.$route.query.requestId;
      }
      return null;
    }
  },
  watch: {
    alternativePartsToBind: function (newVal) {

      if (newVal.length != 0 && this.$route.query.revisionId != ""){
        this.alternativeButtonStatus = false
      }else{
        this.alternativeButtonStatus = true
      }
    },
    selectedSearchedRows: function () {


      //for derive button
      if (this.selectedSearchedRows.DistributorPartId != undefined){
        this.deriveButtonStatus = false

      }else{
         this.deriveButtonStatus = true
      }
      //for edit button
      if (this.selectedSearchedRows.DistributorPartId != undefined) {
        this.editPhysicalButtonStatus = false

      } else {
        this.editPhysicalButtonStatus = true
      }
      //for delete button
      if (this.selectedSearchedRows.DistributorPartId != undefined) {
        this.deletePhysicalButtonStatus = false

      } else {
        this.deletePhysicalButtonStatus = true
      }
      //for request button
      if (this.selectedSearchedRows.DistributorPartId != undefined){
        this.requestButtonStatus = false

      }else{
         this.requestButtonStatus = true
      }
    }
  },
  methods: {
    switchButtons(index) {

      this.tabStatus = index;
    },
    up() {

      this.$store.commit("RESETROUTINGDATA");

      this.$store.dispatch("setSaveStatus", false);
      this.$store.dispatch("resetPropertyToSaving");



      let to = "/PartManager/PartTable";

      this.$router.push({ path: to });

    },
    back(){


      const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiComponent"
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);

      // let to = this.$route.query.from;
      // let from = "";

      // if (Object.keys(this.$route.query).length == 0){

      //   to = "/PartManager/PartTable";
      //   from = "/PartManager/PartSearch";




      //   const query = {
      //     from: this.$route.path,
      //     to: to,
      //     end: true

      //   }

      //   this.$router.push({ path: to, query: query });

      // }

      //#####################################################################
      let query = {};
      let to = "";

      if (this.$store.getters.routingData.length == 0) {
        if (this.$store.getters.sectionPrefix == "pm") {
          to = "/PartManager/PartTable";
        }
        if (this.$store.getters.sectionPrefix == "lm") {
          to = "/LibraryManager/LibraryTable";
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          if (this.$route.path == "ProjectManager/ProjectBom") {
            to = "/ProjectManager/ProjectDetails";
          } else {
            to = "/ProjectManager/ProjectTable";
          }
        }


      } else {
        to = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].from;
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end == true) {
          if (this.$store.getters.sectionPrefix == "pm") {
            to = "/PartManager/PartTable";
          }
          if (this.$store.getters.sectionPrefix == "lm") {
            to = "/LibraryManager/LibraryTable";
          }
          if (this.$store.getters.sectionPrefix == "projm") {
            if (this.$route.path == "ProjectManager/ProjectBom") {
              to = "/ProjectManager/ProjectDetails";
            } else {
              to = "/ProjectManager/ProjectTable";
            }
          }

        }

        query = {
          from: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].to,
          to: to,
          end: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end,
          revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
          id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId,
          requestId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].requestId
        }
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "main") {
          query = {};
        } else if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "details") {
          const goalObj = {
            to: to,
            revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
            id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId,
            selectedBomRow: [{ bomId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].bomId }],
            requestId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].requestId
          }

          this.selectRow(goalObj);
        }

        this.$store.commit("BACKROUTINGDATA");
      }


      this.$router.push({ path: to, query: query })
    },
    selectRow(goalObj) {


      this.$store.dispatch("projm_setSelectedBomRow", goalObj.selectedBomRow)

      let obj = {};

      if (goalObj.to == "/PartManager/PartDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/LibraryManager/LibraryDetails") {
        let id = goalObj.id;

        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/ProjectManager/ProjectDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }




      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);
    },
    importFile(requestId){

      this.$store.dispatch("showLoader", {visible: true, text: "push"});

      let vue = this;

      let lei = vue.$store.getters.requestCreateForm.file.length;



      const obj = {
        requestId: requestId,
        file: vue.$store.getters.requestCreateForm.file[vue.fileCounter],
        lastModified: Tools.IntegerToIntegerUTC(vue.$store.getters.requestCreateForm.file[vue.fileCounter].lastModified)

      }

      let fileName = vue.$store.getters.requestCreateForm.file[vue.fileCounter].name;

      vue.$store.dispatch("rm_importRequestFile", obj)
      .then(function(result){
        console.log(result);
        let obj2 = {};
        if (result.status == "OK"){

          obj2 = {
            result: "Added",
            fileName: fileName,

          }

        }else{


          obj2 = {
            result: result.message,
            fileName: fileName,

          }


        }
        vue.fileFeedback.push(obj2);


        vue.fileCounter++;

          if (vue.fileCounter > lei - 1){

            vue.$store.dispatch("showLoader", { visible: false, text: "" });


            // const reloadObj = {
            //   status: true,
            //   name: "RequestDetailsComponent",
            //   source: ""
            // }
            // vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            if (vue.fileFeedback.length > 0) {

              let func = function () {
                vue.fileFeedback = [];
                vue.toDetails(requestId);
              }


              const dataFiles = {
                fileImportResults: {},
                newRevisionId: null
              }
              for (let i = 0, lei = vue.fileFeedback.length; i < lei; i++){

                const obj = {
                  result: vue.fileFeedback[i].result,


                }

                dataFiles.fileImportResults[vue.fileFeedback[i].fileName] = obj;
              }
              vue.$store.dispatch("showLoader", {visible: false, text:""});
              vue.fileFeedback = [];

              const obj = {
                title: vue.lang.modal_title_PushLibrary,
                text: "",
                type: "push_files",
                buttons: 1,
                buttonName: "Close",
                // buttonWait: buttonWait,
                // commentWait: commentWait,
                size: "xl",
                lang: vue.lang.modal_PushRequest,
                funcNo: "",
                funcYes: "",
                funcCustom: func,
                data: dataFiles
              };

              vue.$store.dispatch("showModalComponent", obj);
            }


          }else{

            vue.importFile(requestId);
          }

      })
    },
    toDetails(requestId) {

      let to = "/RequestManager/RequestDetails";

      this.$store.dispatch("editPropertiesForm", false);



      let routingObject = {
        from: this.$route.path,
        to: to,
        requestId: requestId,
        sourceType: "table",
        sourceId: "",
        sourceRevisionId: "",
        end: true
      }



      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      this.$router.push({ path: to, query: routingObject });
    },
    createRequest() {


      const form = {
        manufacturer: this.selectedSearchedRows.ManufacturerName,
        manufacturerPartNumber: this.selectedSearchedRows.ManufacturerPartNumber
      }

      this.$store.commit("REQUESTCREATEFORM", form);



      let vue = this;

      let funcYes = function () {

        let requestCreateForm = vue.$store.getters.requestCreateForm;

        let obj = {
          manufacturer: requestCreateForm.manufacturer,
          ManufacturerPartNumber: requestCreateForm.manufacturerPartNumber,
          remarks: requestCreateForm.remarks,
          deadLine: requestCreateForm.deadLine,
          priority: requestCreateForm.priority,
          type: requestCreateForm.type,


        }


        vue.$store.dispatch("rm_createRequest", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {
              if (result.data != null) {

                if (vue.$store.getters.requestCreateForm.file.length > 0){

                  vue.fileCounter = 0;

                  vue.importFile(result.data);

                } else {

                  const reloadObj = {
                    status: true,
                    name: "DataTableFilteredOnApiRequestsComponent",
                    source: ""
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                  vue.toDetails(result.data);
                }



              }
            }
          })
      }
      const obj = {
        title: "",
        text: "",
        type: "create_request",
        buttons: 2,
        buttonName: "Close",
        size: "lg",
        lang: vue.lang.modal_CreateRequest,
        funcNo: "",
        funcYes: funcYes,
        funcCustom: "",
        data: {}
      };
      vue.$store.dispatch("showModalComponent", obj);
    },
    displayConnectToSEAlert(status) {
      let vue = this;

      function allowFunc() {

          let obj = {
              distributorPartId: vue.distributorPartId,
              allow: true
          }

          vue.$store.dispatch("pm_setConnectMPNToSE", obj)
          .then(function (result) {

              console.log(result.data)

              if (result.status == "OK") {

                  if (result.data != null) {


                      if (status == 'derive'){
                        vue.derive();
                      }
                      if (status == 'assign'){
                        vue.alternative();
                      }


                  }
              }

          })

      }

      function noAllowFunc() {

          let obj = {
              distributorPartId: vue.distributorPartId,
              allow: false
          }

          vue.$store.dispatch("pm_setConnectMPNToSE", obj)
          .then(function (result) {

            console.log(result.data)

            if (result.status == "OK") {

              if (result.data != null) {

                if (status == 'derive'){
                  vue.derive();
                }
                if (status == 'assign'){
                  vue.alternative();
                }

              }
            }

          })
      }

      const obj = {
          title: vue.lang.modal_title_displayConnectToSEAlert,
          text: vue.lang.alert_displayConnectToSEAlert,
          type: "sure",
          buttons: 2,
          size: "sm",
          funcYes: allowFunc,
          funcNo: noAllowFunc
      };

      vue.$store.dispatch("showAlert", obj);
    },
    checkConnectMPNToSE(status) {

      let vue = this;

      if (this.globalSettings.SEDetails == true) {

        let obj = {
          distributorPartId: this.selectedSearchedRows.DistributorPartId,
        }

        vue.$store.dispatch("pm_getConnectMPNToSE", obj)
        .then(function (result) {

            console.log(result.data)

            if (result.status == "OK") {

                if (result.data != null) {

                    vue.isAllowConnectMPNToSE = result.data.allow;

                    if (vue.isAllowConnectMPNToSE == false) {

                        vue.displayConnectToSEAlert(status);

                    } else {

                      if (status == 'derive'){
                        vue.derive();
                      }
                      if (status == 'assign'){
                        vue.alternative();
                      }

                    }

                }
            }

        })

      } else {
        console.log(status)
        if (status == 'derive'){
          vue.derive();
        }
        if (status == 'assign'){
          vue.alternative();
        }

      }

    },
    derive() {
      let to = "/PartManager/PartDerive";

      const query = {
        from: this.$route.path,
        to: to,
        key: this.selectedSearchedRows.DistributorPartId,
        source: "PartSearch"
      }

      if (this.requestId != null) {
        query.requestId = this.requestId;
      }

      this.$router.push({ path: to, query: query });
    },
    alternative(){


      let vue = this;
      if (this.$store.getters.selectedRows.length != 1){
        let objAlert = {
          title: this.lang.alert_Title,
          text: this.lang.alert_Text + "\n\r ",
          text2: "",
          type: "info",
          buttons: 1,
          size: "sm",
          funcOk: ""
        }

        this.$store.dispatch("showAlert", objAlert);
        return
      }
      let obj = {
        partId: this.$store.getters.selectedRows[0].col___revisionId.partId,
        alternatives: this.$store.getters.alternativePartsToBind
      }
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_assignPhysicals", obj)
      .then((result) => {

        console.log(result)
        if (result.status == "OK"){
          //alert
          if (result.data == 1){

            const obj = {
              text: vue.lang.alert_success_setAlternative,
              time: 5,
              type: "success"
            }

            vue.$store.dispatch("displayFooterAlert", obj);


          }else{
            const obj = {
              text: vue.lang.alert_error_setAlternative,
              time: 5,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          }


        }
      })
    },
    addPhysical() {

      let to = "/PartManager/PartPhysicals";



      const query = {
        from: this.$route.path,
        to: to,
        source: "new",

      }

      if (this.$route.query.id != undefined){
        query.id = this.$route.query.id
      }
      if (this.$route.query.revisionId != undefined){
        query.revisionId = this.$route.query.revisionId
      }

      this.$router.push({ path: to, query: query });
    },
    editPhysical() {
      let to = "/PartManager/PartPhysicals";



      const query = {
        from: this.$route.path,
        to: to,
        source: "update",
        distributorPartId: this.selectedSearchedRows.DistributorPartId
      }

      this.$router.push({ path: to, query: query });
    },
    deletePhysical() {
      let vue = this;

      let deleteFunc = function () {
        let obj = {};
        const objS = {
          distributorId: vue.selectedSearchedRows.DistributorPartId
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deletePhysical", objS)
          .then((result) => {

            console.log(result)

            if (result.status == "OK") {

              if (result.data != null) {
                obj = {
                  text: vue.lang.alert_success_deletePhysicalPart,
                  time: 10,
                  type: "success"
                }

                const reloadObj = {
                  status: true,
                  name: "PhysicalHandmadePartsTableComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              } else {
                obj = {
                  text: vue.lang.alert_error_deletePhysicalPart + ". ",
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_deletePhysicalPart + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_DeletePhysical,
        text: this.lang.alerttitle_DeletePhysical,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
    },
    toggleRightPanel(){

      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;

    },
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }


  },

}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartSearch/Middle/Middle.vue